export enum TreatmentInfoQuestionType {
    SingleChoice = 1,
    MultiChoice = 2,
    Open = 3,
    SingleDropdownChoice = 4,
    Slider = 5,
    Number = 6,
    Wrapper = 7,
    TeethViewer = 8,
    OneColSingleChoice = 9,
    OneColMultiChoice = 10,
    OneColSingleChoiceShowDesc = 11,
    Toggle = 12,
}
